import { useAuth } from '../context/AuthContext';
import { useAppContext } from '../context/AppContext';
import type { SubscriptionTier } from '../types';

export const TIER_LIMITS: Record<SubscriptionTier, { maxDecks: number; maxArticles: number }> = {
  free:  { maxDecks: 2,        maxArticles: 10 },
  tier1: { maxDecks: 10,       maxArticles: 25 },
  tier2: { maxDecks: Infinity, maxArticles: Infinity },
};

function getMonthStart(): number {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1).getTime();
}

export function useSubscription() {
  const { userProfile, isAdmin } = useAuth();
  const { decks, articleQuota } = useAppContext();

  const tier: SubscriptionTier = userProfile?.subscriptionTier ?? 'free';
  const limits = TIER_LIMITS[tier];
  const monthStart = getMonthStart();

  // Use the persistent quota counter instead of counting current articles
  const usedArticles = articleQuota.count;
  const usedDecks = decks.filter(d => d.createdAt >= monthStart).length;

  if (isAdmin) {
    return {
      tier: tier as SubscriptionTier,
      limits: { maxDecks: Infinity, maxArticles: Infinity },
      canAddDeck: true,
      canAddArticle: true,
      isLimited: false,
      usedArticles,
      usedDecks,
    };
  }

  return {
    tier,
    limits,
    canAddDeck: usedDecks < limits.maxDecks,
    canAddArticle: usedArticles < limits.maxArticles,
    isLimited: tier === 'free',
    usedArticles,
    usedDecks,
  };
}
